"use strict";
/**
 * @file Created on 02/27/2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var UserInfo_1 = require("../../user/model/UserInfo");

var ResourceLockResultStatus_1 = require("../enums/ResourceLockResultStatus");

var ResourceLockType_1 = require("../enums/ResourceLockType");
/**
 * @author Tomas Leity
 */


var ResourceLockResultDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ResourceLockResultDTO, _DomainObject_1$Domai);

  /**
   * @param {UserInfo} assignee
   * @param {ResourceLockResultStatus} status
   * @param {string} resourceId
   * @param {ResourceLockType} resourceLockType
   */
  function ResourceLockResultDTO(assignee, status, resourceId, resourceLockType) {
    var _this;

    _classCallCheck(this, ResourceLockResultDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceLockResultDTO).call(this));
    _this.assignee = assignee;
    _this.status = status;
    _this.resourceId = resourceId;
    _this.resourceLockType = resourceLockType;
    return _this;
  }
  /**
   * Checks if lock is successful for current user
   *
   * @returns {boolean}
   */


  _createClass(ResourceLockResultDTO, [{
    key: "lockSuccessful",
    value: function lockSuccessful() {
      return immutable_1.List.of(ResourceLockResultStatus_1.ResourceLockResultStatus.LockAssigned).includes(this.status);
    }
    /**
     * Checks if unlock is successful for current user
     *
     * @returns {boolean}
     */

  }, {
    key: "unlockSuccessful",
    value: function unlockSuccessful() {
      return immutable_1.List.of(ResourceLockResultStatus_1.ResourceLockResultStatus.LockRemoved).includes(this.status);
    }
  }]);

  return ResourceLockResultDTO;
}(DomainObject_1.DomainObject);

exports.ResourceLockResultDTO = ResourceLockResultDTO;
/**
 * @returns {ObjectDesc<ResourceLockResultDTO>}
 */

ResourceLockResultDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ResourceLockResultDTO.name);
  return {
    assignee: builder.opt(builder.obj('assignee', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    })),
    status: builder.senum('status', ResourceLockResultStatus_1.ResourceLockResultStatus, 'enums/ResourceLockResultStatus'),
    resourceId: builder.str('resourceId'),
    resourceLockType: builder.senum('resourceLockType', ResourceLockType_1.ResourceLockType, 'enums/ResourceLockType')
  };
}();